module.exports = __webpack_public_path__ + "img/ermukaohe.e1f52f50.png";